import { render, staticRenderFns } from "./PrivacyBottomSheet.vue?vue&type=template&id=63081de9&"
import script from "./PrivacyBottomSheet.vue?vue&type=script&lang=js&"
export * from "./PrivacyBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyBottomSheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomSheet,VBtn,VIcon,VSheet,VSpacer})
